module.exports = __webpack_public_path__ + "img/poster-common-index.820184b9.png";